import React, {createContext, useContext, FC, PropsWithChildren} from 'react';
import {useTranslation} from '@wix/yoshi-flow-editor';
import {LocaleKeys} from '../../locale-keys/LocaleKeys';

// @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
const LocaleKeysContext = createContext<LocaleKeys>(undefined);

export const LocaleKeysProvider: FC<PropsWithChildren> = ({children}) => {
  const {t} = useTranslation();
  const localeKeys = new LocaleKeys(t);

  return <LocaleKeysContext.Provider value={localeKeys}>{children}</LocaleKeysContext.Provider>;
};

export const useLocaleKeys = () => useContext(LocaleKeysContext);
